var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiFetcher } from "../apiFetcher";
var OidcService = /** @class */ (function () {
    function OidcService() {
        this.apiFetcher = new ApiFetcher();
    }
    OidcService.prototype.updateToken = function (params, realm, authServerUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var config, endpoints, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!authServerUrl || !realm) {
                            return [2 /*return*/, undefined];
                        }
                        config = {
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                            },
                            withCredentials: true,
                            responseType: "json",
                        };
                        endpoints = this.setupOidcEndoints(realm, authServerUrl);
                        return [4 /*yield*/, this.apiFetcher.post(endpoints.token(), params, config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    OidcService.prototype.revokeToken = function (params, realm, authServerUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var config, endpoints, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!authServerUrl || !realm) {
                            return [2 /*return*/, undefined];
                        }
                        config = {
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                            },
                            withCredentials: true,
                            responseType: "json",
                        };
                        endpoints = this.setupOidcEndoints(realm, authServerUrl);
                        return [4 /*yield*/, this.apiFetcher.post(endpoints.revoketoken(), params, config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    OidcService.prototype.fetchKeycloakConfigJSON = function (configUrl) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(configUrl)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OidcService.prototype.fetchOIDCProviderConfigJSON = function (configUrl) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(configUrl)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OidcService.prototype.refreshTokens = function (tokenUrl, params) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiFetcher.post(tokenUrl, params, {
                            headers: {
                                "Content-type": "application/x-www-form-urlencoded",
                            },
                        })];
                    case 1:
                        tokenRes = _a.sent();
                        return [2 /*return*/, tokenRes];
                }
            });
        });
    };
    OidcService.prototype.fetchUserProfile = function (profileUrl, token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(profileUrl, token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OidcService.prototype.fetchUserInfo = function (userInfoUrl, token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(userInfoUrl, token)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OidcService.prototype.fetch = function (url, token) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiFetcher.get(url, {
                            headers: {
                                Accept: "application/json",
                                Authorization: token ? "Bearer " + token : "",
                            },
                        })];
                    case 1:
                        jsonRes = _a.sent();
                        return [2 /*return*/, jsonRes];
                }
            });
        });
    };
    OidcService.prototype.setupOidcEndoints = function (realm, authServerUrl) {
        var _this = this;
        if (!realm) {
            throw new Error('Missing realm');
        }
        return {
            authorize: function () {
                return (_this.getRealmUrl(realm, authServerUrl) + '/protocol/openid-connect/auth');
            },
            token: function () {
                return (_this.getRealmUrl(realm, authServerUrl) + '/protocol/openid-connect/token');
            },
            logout: function () {
                return (_this.getRealmUrl(realm, authServerUrl) + '/protocol/openid-connect/logout');
            },
            revoketoken: function () {
                return (_this.getRealmUrl(realm, authServerUrl) + '/protocol/openid-connect/revoke');
            },
            register: function () {
                return (_this.getRealmUrl(realm, authServerUrl) +
                    '/protocol/openid-connect/registrations');
            },
            userinfo: function () {
                return (_this.getRealmUrl(realm, authServerUrl) +
                    '/protocol/openid-connect/userinfo');
            },
        };
    };
    OidcService.prototype.getRealmUrl = function (realm, authServerUrl) {
        if (typeof authServerUrl === 'undefined') {
            return '';
        }
        if (authServerUrl.charAt(authServerUrl.length - 1) === '/') {
            return authServerUrl + 'realms/' + encodeURIComponent(realm);
        }
        else {
            return authServerUrl + '/realms/' + encodeURIComponent(realm);
        }
    };
    return OidcService;
}());
export { OidcService };
//# sourceMappingURL=OidcService.js.map